module.exports = __webpack_public_path__ + "static/media/okayCheck.5cdcb9dd.svg";